import { useState, useEffect } from 'react';
import Axios from "axios";
import {  GetHiredResourcesByUserID } from '../apiconstants/constants';
import { Link,useLocation } from 'react-router-dom';
import ReactPaginate from "react-paginate";
import nodataimg from "../assets/images/Nodata.jpg"
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import LoadingSpinner from '../helpers/loadingspinner';
import defaultimg from "../assets/images/icons8-circled-user-male-skin-type-3-100.png"
import ConsultantLayout from '../commonlayouts/consultantlayout';
const GetHiredCandidatesByUserID = () => {
  const [offset, setOffset] = useState(0);
  const [data, setData] = useState([]);
  const [perPage] = useState(6);
  const [pageCount, setPageCount] = useState(0);
  const [candidateData, setCandidateData] = useState([{}]);
  const[isLoading,setIsLoading] =useState(false)

  const handlePageClick = (e) => {
    const selectedPage = e.selected;
    setOffset(selectedPage * 6);
  };
  function substring_str(str) {
    if ((str === null) || (str === ' ' || str === undefined))
      return "";
    else
      str = str.toString();
    return str.substring(0, 250) + "...";
  }

  const GetCandidateList = () => {
    setIsLoading(true)
    
    const GetapiUrl = GetHiredResourcesByUserID.APIURL;
    const userID =localStorage.getItem("tokenid")
    const token = localStorage.getItem('jwtToken');
    const params= {
      userId:userID
    }
      Axios.post(GetapiUrl, params, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    }
  })
      .then((result) => {
        setIsLoading(false)
        setCandidateData(result.data);
        const slice = result.data.slice(offset, offset + perPage);
        // setPageCount(Math.ceil(careeradvisordata.length / perPage));
        const items = slice.map((data) => {
          return (
            <>
            {isLoading?<center><LoadingSpinner/></center>:
            <div className="col-sm-12 col-md-6 col-xl-4 col-lg-4 pb-3">
  
              <div className="card" style={{ background: "#f8f8f8",border:'1px solid #00a7ac26',minHeight:140 ,   borderRadius: 20}}>
                 <div className='card-header' style={{ background: "none", minHeight:140 }}>
                  <div className='row'>
                  <div className='col-4'>
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Company Logo</Tooltip>)}>
                  <img alt="Profile Photo" src={data.companyProfileurl.slice(-4)=="blob"?defaultimg:data.companyProfileurl}  style={{height: 80, width: 80, borderRadius: '50%', border: '3px solid #00a7ac'}} />
                  </OverlayTrigger>
                  </div>
                  <div className='col-8'> <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Full Name</Tooltip>)}>
                    <p className="card-title jb-head" style={{ color: "#00a7ac", fontSize: 24 }}><b>{data.fullName}</b></p>
                    </OverlayTrigger>
                    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Company Name</Tooltip>)}>
                    <h5 style={{ fontSize: 18 }}>{data.companyName}</h5>
                    </OverlayTrigger>
                    </div>
              </div>
              </div>
                <div className="card-body" >
                {/* <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>{(data.profileSummery)}</Tooltip>)}>
            <p style={{ fontSize: 14 ,  textAlign: 'justify'}}><i style={{ fontSize: 14,color:"#00a7ac",marginRight:10}} class="fa fa-cogs" aria-hidden="true"></i> {substring_str(data.profileSummery)}  </p>
             </OverlayTrigger> */}
             {/* <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>{(data.technicalSkill)}</Tooltip>)}>
                <p style={{ fontSize: 14 , textAlign: 'justify' }}>
                <i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fa fa-code" aria-hidden="true"></i>
                {substring_str(data.technicalSkill)}
                </p>
                </OverlayTrigger>
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Current Role</Tooltip>)}>
              <p style={{ fontSize: 14 }}><i style={{ fontSize: 14,color:"#00a7ac",marginRight:10}} class="fas fa-user-tie"aria-hidden="true"></i> {data.currentRole} </p>
            </OverlayTrigger> 
            <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Experience</Tooltip>)}>

             <p style={{ fontSize: 14 }}><i style={{ fontSize: 14,color:"#00a7ac",marginRight:10}} class="fas fa-chart-line"aria-hidden="true"></i> {data.experience} Years</p>
            </OverlayTrigger>
           
             <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Prefer Location</Tooltip>)}>
             <p style={{ fontSize: 14 }}><i style={{ fontSize: 14,color:"#00a7ac",marginRight:10}} class="fa fa-map-marker" aria-hidden="true"></i> {data.preferLocation}  </p>
            </OverlayTrigger>
            <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Work Mode</Tooltip>)}>
           <p style={{ fontSize: 14 }}><i style={{ fontSize: 14,color:"#00a7ac",marginRight:10}} class="fas fa-home fa-building" aria-hidden="true"></i> {data.workMode} </p>
            </OverlayTrigger> */}
               <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Current Role</Tooltip>)}>
              <p style={{ fontSize: 14 }}><i style={{ fontSize: 14,color:"#00a7ac",marginRight:10}} class="fas fa-user-tie"aria-hidden="true"></i> {data.currentRole} </p>
            </OverlayTrigger> 
            <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Experience</Tooltip>)}>

             <p style={{ fontSize: 14 }}><i style={{ fontSize: 14,color:"#00a7ac",marginRight:10}} class="fas fa-chart-line"aria-hidden="true"></i> {data.experience} </p>
            </OverlayTrigger>
            <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Skill</Tooltip>)}>
            <p style={{ fontSize: 14 }}><i style={{ fontSize: 14,color:"#00a7ac",marginRight:10}} class="fa fa-code" aria-hidden="true"></i> {data.technicalSkill}  </p>
             </OverlayTrigger>
             <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Country</Tooltip>)}>
             <p style={{ fontSize: 14 }}><i style={{ fontSize: 14,color:"#00a7ac",marginRight:10}} class="fa fa-map-marker" aria-hidden="true"></i> {data.preferLocation}  </p>
            </OverlayTrigger>
            <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Work Mode</Tooltip>)}>
           <p style={{ fontSize: 14 }}><i style={{ fontSize: 14,color:"#00a7ac",marginRight:10}} class="fas fa-home fa-building" aria-hidden="true"></i> {data.workMode} </p>
           </OverlayTrigger> 
                {/* <div className='card-footer text-center' style={{background:"none"}}>
                    {/* <Link style={{ }} to={"/Consultant/EditBenchCandidate?candidatesID=" + data.candidatesID}>
                      <OverlayTrigger placement="bottom" overlay={(props) =>
                      (
                        <Tooltip id="tooltip" {...props}> Edit</Tooltip>
                      )}>
                       
                        <button style={{background:"none",border:"none"}}><i class="fa fa-edit" aria-hidden="true" style={{fontSize:20,color:"#00a7ac"}}></i></button>

                      </OverlayTrigger>
                    </Link> */}
                    {/* <Link style={{ float:"right" }} to={"/Consultant/EditBenchCandidate?candidatesID=" + data.candidatesID}>
                      <OverlayTrigger placement="bottom" overlay={(props) =>
                      (
                        <Tooltip id="tooltip" {...props}> View</Tooltip>
                      )}>
                       
                        <button style={{background:"none",border:"none"}}><i class="fa fa-eye" aria-hidden="true" style={{fontSize:20,color:"#00a7ac",}}></i></button>

                      </OverlayTrigger>
                    </Link> */}
                
                  {/* </div> */}
  
                </div>
                
              </div>
           
  
  
          </div>
          
            }
         </>
          );
        });
        setData(items);
        setPageCount(Math.ceil(result.data.length / perPage));
        //  alert(pageCount);
      }).catch(
        function (error) {
          console.log("Error" + error)
        })
  }
  useEffect(() => {
    GetCandidateList();
  }, [offset]
  );
  return (
    <>
    <ConsultantLayout>
      <div className='container'>

        <h2 className="my-certificates mt-3" style={{color:"#00a7ac"}}>List of Hired Candidates</h2>

        <hr />
        {
          candidateData.length > 0 &&
          <div className="row mt-5 pb-3">
         {isLoading?<center><LoadingSpinner/></center>:  <> {data}</>}
          </div>
        }
      </div>
      {
        candidateData.length === 0 &&
        <div className="pb-5 text-center">
          <img title='No Data' className='no-data-img ' src={nodataimg} style={{ height: 350, }} />
        </div>
      }
      {
        candidateData.length > 6 &&
        <ReactPaginate
          previousLabel={"Prev"}
          nextLabel={"Next"}
          breakLabel={"..."}
          breakClassName={"break-me"}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={10}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          subContainerClassName={"pages pagination"}
          activeClassName={"active"}
          disabledClassName={"disable-pagination-button"}
        />
      }
</ConsultantLayout>
    </>
    

  );
}
export default GetHiredCandidatesByUserID;